export const messages = {
  vi: {
    'app.home': 'Trang chủ FnB Customer',
    'app.guest': 'Khách',
    'app.loading': 'Đang tải…',
    'app.footer': 'NexaCore · Gọi món nhanh tại cửa hàng',
    'action.retry': 'Thử lại',
    'action.home': 'Về trang bắt đầu',
    'action.close': 'Đóng',
    'entry.loadingTitle': 'Đang kiểm tra mã QR',
    'entry.loadingDescription': 'Đang xác nhận cửa hàng và phiên gọi món an toàn…',
    'entry.invalidTitle': 'Mã QR không hợp lệ',
    'entry.invalidDescription': 'Vui lòng quét lại mã QR được đặt tại cửa hàng.',
    'entry.expiredTitle': 'Mã QR đã hết hạn',
    'entry.expiredDescription':
      'Mã này không còn sử dụng được. Vui lòng quét mã QR mới tại cửa hàng.',
    'entry.inactiveTitle': 'Cửa hàng chưa hoạt động',
    'entry.inactiveDescription': 'Cửa hàng hiện chưa thể nhận đơn trực tuyến.',
    'entry.closedTitle': 'Cửa hàng đang đóng cửa',
    'entry.closedDescription': 'Vui lòng quay lại trong giờ hoạt động của cửa hàng.',
    'entry.rateTitle': 'Bạn thao tác hơi nhanh',
    'entry.rateDescription': 'Vui lòng đợi một chút rồi thử lại.',
    'entry.offlineTitle': 'Không có kết nối mạng',
    'entry.offlineDescription': 'Kiểm tra kết nối Internet rồi thử lại.',
    'entry.unexpectedTitle': 'Chưa thể bắt đầu gọi món',
    'entry.unexpectedDescription': 'Đã xảy ra lỗi ngoài dự kiến. Vui lòng thử lại.',
    'tracking.heading': 'Tiến trình đơn hàng',
    'tracking.payment': 'Thanh toán',
    'tracking.fulfillment': 'Chuẩn bị món',
    'tracking.cancelled': 'Đơn đã được ghi nhận hủy.',
    'cancel.title': 'Yêu cầu hủy đơn',
    'cancel.description':
      'Cửa hàng sẽ áp dụng quy tắc hủy hiện hành. Khả năng hủy được hệ thống kiểm tra lại khi gửi.',
    'cancel.reason': 'Lý do',
    'cancel.submit': 'Gửi yêu cầu hủy',
    'cancel.pending': 'Đang gửi…',
    'cancel.notAllowed': 'Đơn hiện không còn đủ điều kiện hủy.',
    'cancel.denied': 'Không thể xác minh quyền truy cập đơn.',
    'cancel.failed': 'Chưa gửi được yêu cầu. Vui lòng thử lại.',
  },
  en: {
    'app.home': 'FnB Customer home',
    'app.guest': 'Guest',
    'app.loading': 'Loading…',
    'app.footer': 'NexaCore · Fast in-store ordering',
    'action.retry': 'Try again',
    'action.home': 'Back to start',
    'action.close': 'Close',
    'entry.loadingTitle': 'Checking QR code',
    'entry.loadingDescription': 'Securely validating the store and ordering session…',
    'entry.invalidTitle': 'Invalid QR code',
    'entry.invalidDescription': 'Please scan the QR code displayed at the store.',
    'entry.expiredTitle': 'QR code expired',
    'entry.expiredDescription': 'This code is no longer valid. Please scan a new store QR code.',
    'entry.inactiveTitle': 'Store unavailable',
    'entry.inactiveDescription': 'The store cannot accept online orders right now.',
    'entry.closedTitle': 'Store is closed',
    'entry.closedDescription': 'Please return during store opening hours.',
    'entry.rateTitle': 'Too many attempts',
    'entry.rateDescription': 'Please wait a moment and try again.',
    'entry.offlineTitle': 'No network connection',
    'entry.offlineDescription': 'Check your connection and try again.',
    'entry.unexpectedTitle': 'Unable to start ordering',
    'entry.unexpectedDescription': 'An unexpected error occurred. Please try again.',
    'tracking.heading': 'Order progress',
    'tracking.payment': 'Payment',
    'tracking.fulfillment': 'Order preparation',
    'tracking.cancelled': 'The order cancellation has been recorded.',
    'cancel.title': 'Request cancellation',
    'cancel.description':
      'The store cancellation rules apply and eligibility is checked again by the server.',
    'cancel.reason': 'Reason',
    'cancel.submit': 'Submit cancellation',
    'cancel.pending': 'Submitting…',
    'cancel.notAllowed': 'This order is no longer eligible for cancellation.',
    'cancel.denied': 'Unable to verify order access.',
    'cancel.failed': 'Unable to submit the request. Please try again.',
  },
} as const;

export type MessageKey = keyof typeof messages.vi;
export type CustomerLocale = keyof typeof messages;
let activeLocale: CustomerLocale = 'vi';
export const setLocale = (locale: CustomerLocale) => {
  activeLocale = locale;
  document.documentElement.lang = locale;
};
export const t = (key: MessageKey): string => messages[activeLocale][key];
